<template>
	<div>
		<div class="modal-drag-custom-drag limit-height-size" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
			<modal
				name="custom_drag_modal"
				:style="{ zIndex: indexModalIndex }"
				hide-overlay
				draggable=".drag-header"
				:clickToClose="true"
			@before-close="closeModal"
				:focusTrap="true"
				:adaptive="true"
				:resizable="false"
				height="auto"
				width="90%"
				:maxWidth="900"
			>
				<v-card>
					<v-card-title class="pa-0 drag-header">
						<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
							<div class="d-flex flex-row align-center">
								<v-icon color="white" small class="info-icon mr-2">mdi-account</v-icon>
								<div class="d-flex align-center">
									<p class="mb-0 font-weight-bold text-primary title">Detalle Pre Proyecto<span v-if="preproject"> | Nº {{ preproject.project_line_info?.id }}</span></p>
								</div>
							</div>
							<div class="d-flex align-center">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-badge
											:value="!!totalNewMessages"
											:content="totalNewMessages"
											color="green"
											overlap
										>
											<v-btn
												fab
												dark
												x-small
												color="#FF120B"
												class="mx-1"
												@click="openChatModal"
												v-bind="attrs"
												v-on="on"
											>
												<v-icon small dark>mdi-chat-outline</v-icon>
											</v-btn>
										</v-badge>
									</template>
									<span>Ver Chat</span>
								</v-tooltip>
								<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
									<v-icon dark>mdi-close</v-icon>
								</v-btn>
							</div>
						</div>
					</v-card-title>
					<v-card-text class="pa-4">
						<v-row class="mb-4" v-if="!$store.state.preprojects.loadingPreProject">
							<v-col cols="12" class="mb-0 pb-0">
								<v-btn-toggle
									v-model="selectedCard"
									dense
									class="d-flex flex-row pb-3 custom-toggle-btns"
									style="overflow-x: scroll;"
								>
									<v-btn :value="1" class="flex-grow-1"
										:color="selectedCard == 1 ? '#FF1209':''">
										<p class="mb-0 caption font-weight-bold" :class="selectedCard == 1 ? 'white--text':''">Datos</p>
									</v-btn>
									<v-btn :value="2" class="flex-grow-1"
										:color="selectedCard == 2 ? '#FF1209':''">
										<p class="mb-0 caption font-weight-bold" :class="selectedCard == 2 ? 'white--text':''">Documentos Y Planos Normativos</p>
									</v-btn>
									<v-btn :value="3" class="flex-grow-1"
										:color="selectedCard == 3 ? '#FF1209':''">
										<p class="mb-0 caption font-weight-bold" :class="selectedCard == 3 ? 'white--text':''">Archivos</p>
									</v-btn>
									<v-btn :value="4" class="flex-grow-1"
										:color="selectedCard == 4 ? '#FF1209':''">
										<p class="mb-0 caption font-weight-bold" :class="selectedCard == 4 ? 'white--text':''">Informes / Presupuestos</p>
									</v-btn>
								</v-btn-toggle>
							</v-col>
						</v-row>
						<div fluid class="crm-conversation pa-2">
							<v-row class="mb-4" v-if="$store.state.preprojects.loadingPreProject">
								<v-col cols="12">
									<div class="d-flex flex-column justify-center align-center">
										<v-progress-circular
											:size="50"
											:width="5"
											color="rgba(0,0,0,0.2)"
											class="mb-3"
											indeterminate
										></v-progress-circular>
										Cargando Información
									</div>
								</v-col>
							</v-row>
							<div v-else-if="preproject">
								<v-row>
									<v-col cols="12" v-if="selectedCard == 1">
										<v-card class="mb-4">
											<v-card-text class="py-2">
												<div class="d-flex align-center justify-space-between">
													<div class="d-flex justify-space-between align-center flex-grow-1">
														<p class="font-weight-bold body-2 px-1 mb-0 mr-2">Datos Usuario</p>
														<!-- <ChangeProjectClient itemType="preproject" :itemId="preproject.id" :clientChanged="getPreprojectInfo"/> -->
													</div>
												</div>
												<v-divider class="my-1"></v-divider>
												<div class="py-2">
													<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
														<div style="width: 190px">Nombre</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject.client.profile?.name}} {{preproject.client.profile?.lastname}} {{preproject.client.profile?.second_lastname}}</b>
														<div class="action-container"></div>
													</div>
													<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
														<div style="width: 190px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject.client.email}}</b>
														<div class="action-container"></div>
													</div>
													<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
														<div style="width: 190px">Teléfono</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject.client.profile?.phone}}</b>
														<div class="action-container"></div>
													</div>
												</div>
											</v-card-text>
										</v-card>
										<GeneralDataSection />
									</v-col>
									<v-col cols="12" v-if="selectedCard == 2">
										<DocumentsTable />
									</v-col>
									<v-col cols="12" v-if="selectedCard == 3">
										<FileSection :to_modal="true"/>
									</v-col>
									<v-col cols="12" v-if="selectedCard == 4">
										<Documents :item="preproject" :showContracts="false"/>
									</v-col>
								</v-row>
								<BudgetSectionModal />
								<ChatSectionModal />
							</div>
						</div>
					</v-card-text>
				</v-card>
			</modal>
		</div>
    <!-- <v-dialog
			v-model="selectedFileToModal"
      max-width="800px"
			persistent
      scrollable
			style="z-index: 9999"
    >
      <v-card min-height="90vh">
				<FileViewerSection />
        <v-card-actions class="pa-0">
					<div class="d-flex flex-grow-1 justify-end py-2 px-8">
						<v-btn
							depressed
							color="#FF1209"
							class="mb-0"
							small
							dark
							@click="$store.commit('general/setSelectedFile', null)"
						>
							<v-icon small>mdi-close</v-icon>
							<p class="mb-0 ml-2 caption">Cerrar</p>
						</v-btn>
					</div>
				</v-card-actions>
			</v-card>
		</v-dialog> -->
	</div>
</template>

<script>
import moment from 'moment'
import { gmapApi } from 'vue2-google-maps'
import {addFileToPreProject, removeFileFromPreProject, addPreProjectBudgetsPart, removePreProjectBudgetsPart, updatePreProjectInfo, setResponsible} from '@/helpers/api/preprojects'
import {createChatRoom, addUserToChatRoom} from '@/helpers/api/chats'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import DocumentsTable from '@/components/Views/PreProjects/DocumentsTable'
import GeneralDataSection from '@/components/Views/PreProjects/Sections/GeneralDataSection'
import FileSection from '@/components/Views/PreProjects/Sections/FileSection'
import Documents from '@/components/Helpers/Components/Documents'
// import FileViewerSection from '@/components/Views/PreProjects/Sections/FileViewerSection'
import BudgetSectionModal from '@/components/Views/PreProjects/Sections/BudgetSectionModal'
import ChatSectionModal from '@/components/Views/PreProjects/Sections/ChatSectionModal'
import {markAsReaded} from '@/helpers/api/notifications'
// import ChangeProjectClient from '@/components/Helpers/Components/ChangeProjectClient'

export default {
	name: 'PreProjectModal',
	components: {DocumentsTable, GeneralDataSection, FileSection, ChatSectionModal, BudgetSectionModal, Documents},
  data() {
    return {
			indexModal: + new Date(),
			searchCity: '',
			selectedCard: 1,
			cityMenu: false,
			selectedFile: null,
			loadingChatCreation: false,
			add_chat_users_id: [],
			showNewBudgetPart: false,
			newBudgetPart: {
				value: null,
				concept: null,
				preproject_id: null
			},
			filesToUpload: [],
			loadingRemoveFile: false,
			mapZoom: 7,
      zoomInterval: null,
      isZooming: false,
			itemsAddress: [],
			loadingAddress: false,
			search: '',
			autocompleteService: null,
			tab: null,
			items: ['Información', 'Conversación', 'Correos Enviados', 'Informes'],
			reportTemplate: null,
			loading: false,
			editValue: false,
			editProjectDetail: false,
			editScheduleTitle: false,
			editUser: false,
			editAddress: false,
			editProjectAddress: false,
			newProjectAddress: null,
			editProjectRol: false,
			newProjectRol: null,
			newValueCrm: null,
			newScheduleTitle: null,
			newProjectDetail: null,
			loadingEditUser: false,
			editProjectDescription: false,
			newProjectDescription: null,
			reportEditor: '',
			menuTemplates: false,
			cc_report: null,
			scheduledUserId: null,
			changingScheduleUser: false,
			subject: 'Informe Visita Técnica',
			report_title: 'Informe Visita Técnica Revisión Normativa',
			activePanel: 2,
			templateName: null,
			userData: {
				name: null,
				email: null,
				phone: null
			},
			cachingItems: false,
			newAddress: {address: null, coordinates: null},
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
			phoneRule: [
				v => !!v || 'Campo requerido',
				v => /^569\d{8}$/.test(v) || 'Debe tener 11 dígitos y empezar con 569',
			],
    };
  },
  computed: {
		totalNewMessages() {
			if (this.$store.state.notifications.notifications && this.$store.state.notifications.notifications.length > 0) {
					const notifications = this.$store.state.notifications.notifications.filter(notification => {
							return notification.item_type == 3 && notification.item_id && !notification.readed
					});
					return notifications.length;
			}
			return null;
		},
		notificationChat(){
			if(this.$store.state.notifications.notifications && this.$store.state.notifications.notifications.length > 0){
				const notification = this.$store.state.notifications.notifications.find((notification) => {
					return notification.item_id == this.$store.state.preprojects.preProject.id && notification.item_type == 3 && !notification.readed
				})
				return notification
			}
			return null
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		google: gmapApi,
    selectedFileToModal() {
      return this.$store.state.general.selectedFile
    },
		cities(){
			return this.$store.state.general.countryCities.filter(city => city.name.toLowerCase().includes(this.searchCity.toLowerCase()))
		},
		docView(){
			if(this.selectedFile){
				const fileExtension = this.selectedFile.path.split('.').pop().toLowerCase();
				let result = {
						url: null,
						type: null,
						extension: fileExtension,
				};

				if (fileExtension === 'pdf') {
						result.url = this.selectedFile.file_link;
						result.type = 'doc';
				} else if (['doc', 'docx', 'xlsx', 'xls'].includes(fileExtension)) {
						result.url = `https://docs.google.com/gview?url=${encodeURIComponent(this.selectedFile.file_link)}&embedded=true`;
						result.type = 'doc';
				} else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(fileExtension)) {
						result.url = this.selectedFile.file_link;
						result.type = 'image';
				} else {
						result.type = 'other';
				}
				return result
			}
			return null
		},
		userListChat(){
			return this.$store.state.users.usersList
		},
		editPermission(){
			return this.$checkPermissions(['edit_crm']) || this.scheduledUserId == this.$store.state.user.userInfo.id
		},
		scheduledUserName(){
			const user = this.$store.state.users.usersList.find((user) => {
				return user.id == this.scheduledUserId
			})
			if(!user){ return null }
			return user.profile.name + ' ' + user.profile.lastname + ' ' + user.profile.second_lastname
		},
		loadingUsers(){
			return this.$store.state.users.loadingUserList || this.changingScheduleUser
		},
		vtStatusText(){
			if(this.conversation.schedule.closure.length > 0){
				return 'Realizada'
			}
			else if(this.conversation.schedule.status == 1){
				return 'Esperando confirmación/pago'
			}
			return 'Confirmada'
		},
    preproject() {
      return this.$store.state.preprojects.preProject
    },
    reportTemplates() {
      return this.$store.state.vt.vtReportTemplates
    },
		conversationMessages(){
      return this.$store.state.crm.conversation.messages
		},
		geoAddress(){
			if(this.conversation && this.conversation.project_info && this.conversation.project_info.coordinates){
				return {lat: this.conversation.project_info.coordinates.coordinates[1], lng: this.conversation.project_info.coordinates.coordinates[0]}
			}
			return null
		},
		sentEmailDiff(){
			if(this.conversation.schedule && this.conversation.schedule.request_email.length > 0){
				const current = moment()
				const startTime = this.conversation.schedule.request_email[0].created_at
				var duration = moment.duration(current.diff(startTime))
				var hours = duration.asHours()
				return hours
			}
			else if(this.conversation.schedule.request_email.length == 0){
				return -1
			}
			return null
		},
		vtStatus(){
			if(this.conversation.schedule && this.conversation.schedule.status == 2 && this.conversation.schedule.request_email.length > 0){
				return {
					text: 'Informe Enviado',
					color: 'success'
				}
			}
			else if(this.conversation.schedule){
				return {
					text: 'Informe Pendiente',
					color: 'warning'
				}
			}
			return null
		}
  },
	watch: {
    search(newSearch) {
			this.cachingItems = false
      if (newSearch) {
        this.googleSearch(newSearch);
      } else {
        this.itemsAddress = []; // Limpiar los resultados si no hay búsqueda
      }
    },
		preproject(newValue){
			if(newValue){
				if(newValue.chat_room){
					this.add_chat_users_id = newValue.chat_room.users.map(user => user.user_id)
				}

				if(this.preproject?.pl_signed_contract){
					const data = {
						message: 'Este Pre Proyecto está en una línea de proyecto con un contrato firmado, por lo tanto no puede ser editado.',
						title: 'Línea de Proyecto con Contrato',
						created: new Date(),
						type: 'warning',
						icon: 'mdi-exclamation',
						color: 'orange'
					}
					this.$store.dispatch('general/addMessage', data)
				}
			}
		},
		activePanel(newValue){
			if(newValue >= 0){
				this.$store.dispatch('vt/getVtReportTemplates')
			}
		},
		reportTemplates(newValue){
			if(newValue && this.reportTemplate){
				const reportSelected = newValue.find((report) => {
					return this.reportTemplate.id == report.id
				})
				if(reportSelected){
					this.onChangeReportTemplate(reportSelected)
				}
			}
		}
	},
	mounted(){
		try {
			this.$modal.show('custom_drag_modal')
			this.$store.commit('general/addOpenModalOrders', this.indexModal)
			this.$store.dispatch('users/getUserFromCompany')
			this.getPreprojectInfo()
			this.$nextTick(() => {
				this.$gmapApiPromiseLazy().then(() => {
					this.autocompleteService = new this.google.maps.places.AutocompleteService()
				})
			});
			eventBus.$on('reloadInformation', this.getPreprojectInfo)
		} catch (error) {
			console.log('Error: ', error)
		}
	},
	beforeDestroy(){
		eventBus.$off('reloadInformation', this.getPreprojectInfo)
		this.$store.commit('preprojects/setPreProject', null)
		this.$store.commit('preprojects/setPreProjectModalId', null)
	},
  methods: {
		openChatModal(){
			if(this.notificationChat){
				this.markNotificationAsRead(this.notificationChat.id)
			}
			this.$store.commit('preprojects/setOpenChatModal', !this.$store.state.preprojects.openChatModal)
		},
		async markNotificationAsRead(notification_id){
			const tasks = await markAsReaded({id: notification_id})
			if(tasks.code == 200){
				this.$store.dispatch('notifications/getNotifications', 10)
			}
		},
		closeModal(){
			this.$store.commit('preprojects/setPreProject', null)
			this.$store.commit('preprojects/setPreProjectModalId', null)
		},
		getPreprojectInfo(){
			this.$store.dispatch('preprojects/getPreProject', {preproject_id: this.$store.state.preprojects.preProjectModalId})
		},
		openBudgetModal(){
			localStorage.setItem('last_working_budget', JSON.stringify(this.preproject.budget))
			this.$router.push({ name: 'BudgetDetail', query: { id: this.preproject.budget.id } })
		},
		getIconFile(file){
			const fileExtension = file.path.split('.').pop().toLowerCase();
			if (fileExtension === 'pdf') {
					return { icon: 'mdi-file-pdf-box', color: '#FF0000' };
			} else if (fileExtension === 'doc' || fileExtension === 'docx') {
					return { icon: 'mdi-file-word', color: '#1E88E5' };
			} else if (fileExtension === 'xls' || fileExtension === 'xlsx') {
					return { icon: 'mdi-file-excel', color: '#4CAF50' };
			} else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(fileExtension)) {
					return { icon: 'mdi-file-image', color: '#FFD700' };
			} else {
					return { icon: 'mdi-file', color: '#9E9E9E' };
			}
		},
		startEditProjectDetail(){
			this.editProjectDetail = !this.editProjectDetail
			this.newProjectDetail = this.preproject.name
		},
		startEditProjectAddress(){
			this.editProjectAddress = !this.editProjectAddress
			this.newProjectAddress = this.preproject.info?.address?.address
		},
		startEditProjectRol(){
			this.editProjectRol = !this.editProjectRol
			this.newProjectRol = this.preproject.info?.address?.rol
		},
		startEditTitle(){
			this.editScheduleTitle = !this.editScheduleTitle
			this.newScheduleTitle = this.conversation.schedule.user_schedule?.title
		},
		async onAddUserConfirm(){
			await addUserToChatRoom({
				chat_room_id: this.preproject.chat_room.id,
				users_id: this.add_chat_users_id,
			})
			this.getPreprojectInfo()
		},
		async createPreProjectChatRoom(){
			this.loadingChatCreation = true
			const data = {
				name: this.preproject.name,
				type: "App\\Models\\PreProject",
				type_id: this.$store.state.preprojects.preProjectModalId,
				users_id: [this.preproject.client_id]
			}
			await createChatRoom(data)
			this.getPreprojectInfo()
			this.loadingChatCreation = false
		},
		showNewBudgetPartStart(){
			this.newBudgetPart = {
				value: null,
				concept: null,
				preproject_id: this.$store.state.preprojects.preProjectModalId
			}
			this.showNewBudgetPart = true
		},
		isNumberKey(event) {
			const charCode = event.which ? event.which : event.keyCode;
			if (charCode < 48 || charCode > 57) {
				event.preventDefault();
			}
		},
    startZoomIn() {
      this.isZooming = true;
      this.zoomIn();
    },
    stopZoomIn() {
      this.isZooming = false;
      if (this.zoomInterval) {
        clearInterval(this.zoomInterval);
        this.zoomInterval = null;
      }
    },
    zoomIn() {
      if (this.zoomInterval) {
        clearInterval(this.zoomInterval);
      }

      this.zoomInterval = setInterval(() => {
        if (this.isZooming && this.mapZoom < 20) {
          this.mapZoom += 1;
					
					const map = this.$refs.vtMap.$mapObject;
					if (map) {
						map.setCenter(this.geoAddress); // El mapa se vuelve a centrar en el mismo punto
					}
        } else {
          clearInterval(this.zoomInterval);
          this.zoomInterval = null;
        }
      }, 100);
    },
    updateZoom(zoom) {
      this.mapZoom = zoom;
    },
    googleSearch(query) {
      const options = {
        input: query,
				componentRestrictions: { country: 'CL' }
      };
      this.autocompleteService.getPlacePredictions(options, (predictions, status) => {
        if (status === this.google.maps.places.PlacesServiceStatus.OK) {
          this.itemsAddress = predictions.map(prediction => ({
            text: prediction.description,
            value: prediction 
          }));
        } else {
          console.error('Error fetching predictions: ', status);
          this.itemsAddress = [];
        }
      });
    },
		async getPlaceDetails(placeId) {
			if (typeof this.google !== 'undefined' && this.google.maps) {
				const service = new this.google.maps.places.PlacesService(document.createElement('div'));
				
				service.getDetails({ placeId }, (place, status) => {
					if (status === this.google.maps.places.PlacesServiceStatus.OK) {
						const { geometry } = place;
						this.newAddress.coordinates = {
							lat: geometry.location.lat(),
							lng: geometry.location.lng()
						}
						this.updateAddress(this.newAddress)
					}
				});
			} else {
				console.error('Google Maps API no está cargada');
			}
		},
		reloadInformationEvent(){
			eventBus.$emit('reloadInformation', {preproject_id: this.preproject.id})
		},
		async sendEditProjectRol(){
			const data = {
				preproject_id: this.$store.state.preprojects.preProjectModalId,
				rol: this.newProjectRol
			}
			await updatePreProjectInfo(data)
			this.getPreprojectInfo()
			this.editProjectRol = false
			this.newProjectRol = null
		},
		startEditDescription(){
			this.editProjectDescription = !this.editProjectDescription
			this.newProjectDescription = this.preproject.description
		},
		async sendEditProjectDescription(){
			const data = {
				preproject_id: this.$store.state.preprojects.preProjectModalId,
				description: this.newProjectDescription
			}
			await updatePreProjectInfo(data)
			this.getPreprojectInfo()
			this.editProjectDescription = false
			this.newProjectDescription = this.preproject.description
		},
		async sendEditProjectDetail(){
			const data = {
				preproject_id: this.$store.state.preprojects.preProjectModalId,
				name: this.newProjectDetail
			}
			await updatePreProjectInfo(data)
			this.getPreprojectInfo()
			this.editProjectDetail = false
			this.newProjectDetail = this.preproject.name
			this.reloadInformationEvent()
		},
		async changePreProjectCity(district_id){
			const data = {
				preproject_id: this.$store.state.preprojects.preProjectModalId,
				district_id
			}
			this.cityMenu = false
			await updatePreProjectInfo(data)
			this.getPreprojectInfo()
			this.editProjectRol = false
			this.newProjectRol = null
			this.reloadInformationEvent()
		},
		async changePreProjectResponsible(responsible_id){
			const data = {
				preproject_id: this.$store.state.preprojects.preProjectModalId,
				responsible_id
			}
			await setResponsible(data)
			this.getPreprojectInfo()
			this.reloadInformationEvent()
		},
		async updateAddress(address){
			const data = {
				...{preproject_id: this.$store.state.preprojects.preProjectModalId},
				...address
			}
			this.loadingAddress = true
			await updatePreProjectInfo(data)
			this.getPreprojectInfo()
			this.loadingAddress = false
			this.editProjectAddress = false
			this.newProjectAddress = null
			this.reloadInformationEvent()
		},
    change(value) {
			console.log('value', value)
			this.getPlaceDetails(value.value.place_id)
      this.newAddress.address = value.text
    },
		startCloseAgenda(){
			if(this.conversation.schedule){
				this.$store.commit('vt/setAgendaClosureModal', this.conversation.schedule.id)
			}
		},
		async editReportTemplate(reportTemplate, duplcating = false){
			const rt = {...reportTemplate}
			if(duplcating){
				rt.name = rt.name + ' (Copia)'
				delete rt.id
			}
			this.$store.commit('vt/setNewReportTemplateEditing', rt)
      this.$store.commit('vt/setNewReportTemplateModal', true)
		},
		cleanReportEditor(){
			this.reportEditor = ''
		},
		onChangeReportTemplate(report_template){
			this.report_title = report_template.name
			this.reportEditor = report_template.content
		},
		showFilePicker() {
			const input = this.$refs.fileInput;
			input.onchange = async (event) => {
				const file = event.target.files[0]
				this.filesToUpload.push({
					preproject_id: this.$store.state.preprojects.preProjectModalId,
					file,
					name: null,
					loading: false
				})
				input.value = null
			};
			input.click();
		},
		async uploadFile(file, index){
			file.loading = true
			const formData = new FormData()
			formData.append('file', file.file)
			formData.append('preproject_id', file.preproject_id)
			file.name && formData.append('name', file.name)
			await addFileToPreProject(formData)
			this.getPreprojectInfo()
			this.filesToUpload.splice(index, 1)
			file.loading = false
		},
		removeFileToUpload(index){
			this.filesToUpload.splice(index, 1)
			console.log('this.filesToUpload: ', this.filesToUpload)
		},
		async removeFile(){
			this.loadingRemoveFile = true
			await removeFileFromPreProject({file_id: this.selectedFile.id})
			this.selectedFile = null
			this.getPreprojectInfo()
			this.loadingRemoveFile = false
		},
		downloadFile(){
			window.open(this.selectedFile.file_link, '_blank')
		},
		toCRM(crm_id) {
			this.$router.push({ name: 'Conversation', params: { id: crm_id } })
		},
		async addNewPreProjectBudgetsPart(){
			const data = {...this.newBudgetPart}
			this.newBudgetPart = {
				value: null,
				concept: null,
				preproject_id: this.$store.state.preprojects.preProjectModalId
			}
			this.showNewBudgetPart = false
			await addPreProjectBudgetsPart(data)
			this.getPreprojectInfo()
		},
		async deleteBugdetPart(budget_part){
			await removePreProjectBudgetsPart({budget_part_id: budget_part.id})
			this.getPreprojectInfo()
		}
  },
};
</script>

<style scoped>
	.messages-container{
		display: flex;
		flex-direction: column;
		padding: 10px;
		flex: 1;
		border-radius: 10px;
		height: 400px;
		overflow-y: scroll;
	}
	.single-message{
		background-color: rgb(217, 239, 217);
		border: 1px solid rgb(197, 232, 197);
		padding: 4px 8px;
		max-width: 80%;
		border-radius: 10px;
		font-size: 14px;
		margin-bottom: 8px;
		text-transform: none;
	}
	.single-message.assistant{
		background-color: rgb(213, 211, 211);
		border: 1px solid rgb(193, 191, 191);
		align-self: flex-end;
	}
	.template-list-item:hover{
		background-color: rgba(0,0,0,0.2);
	}
	.menu-bg-white{background: white;}
	.single-file-container{
		background-color: white;
		border: 1px solid rgb(193, 191, 191);
	}
	.file-icon-buttons{
		width: 70px;
		height: 80px;
		border: 1px solid rgb(213, 211, 211);
		cursor: pointer;
	}
	.file-icon-buttons:hover{
		background-color: rgb(239, 239, 239);
	}
	.file-icon-buttons.selected{
		background-color: rgb(213, 211, 211);
	}
	.truncate-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
	}
	.image-viewer{
		background-image: url('data:image/gif;base64,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');
		background-position: center;
		background-repeat: no-repeat;
	}
	.item-background-hover:hover{
		background-color: rgba(0,0,0,0.1);
	}
	.action-container{
		width: 30px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.custom-toggle-btns .v-btn--active:before{
		opacity: 0;
	}
</style>
<style>
	.crm-conversation .single-message p{
		margin-bottom: 0;
	}
</style>